import { APICompsSchema } from "@unit/apis";

export const HEADER_HEIGHT = 48;
/** バナー領域の高さ。モバイルの高さは要件§3.3 で未定義のため暫定で全幅同じ値を使う（#1551 が実データ接続時に見直す）。 */
export const BANNER_HEIGHT = 80;
export const SIDEBAR_WIDTH = 240;

/*
 * レイアウト数値の正本（要件 Ver.2.1.0 §3.2 / §3.3 / §3.3.1）。
 * テスト用モデル（`src/test/fixtures/home-layout.ts`）もここを参照し、数値を二重に持たない。
 */

/** 右カラム幅（固定）。900px 未満・900〜1199px ではセンター下部へ移るため横幅としては使わない。 */
export const HOME_RIGHT_COLUMN_WIDTH = 320;
/**
 * センターカラムの最小幅。保証下限 1200px から逆算した値（1200 − 240 − 320 = 640）。
 * ⚠ CSS の `min-width` として置かない。900px 未満ではセンターが画面幅いっぱい（375px など）になり横あふれするため。
 *   検証・モデル用の期待値としてのみ使う。
 */
export const HOME_CENTER_MIN_WIDTH = 640;
/** センターカラムの左右パディング（片側）。センター内幅 = センター外幅 − この値 × 2。 */
export const HOME_CENTER_PADDING_X = 24;

/**
 * シェルが使うブレークポイント。`packages/styles` の MUI テーマ（`sm:600 / md:900 / lg:1200`）の写しで、
 * **新しい値を足すためのものではない**。判定は必ず `useCustomMediaQuery()` 経由で行う（要件§3.3）。
 */
export const SHELL_BREAKPOINTS = {
  /** これ未満はサイドバーを Drawer 化し1カラムにする */
  md: 900,
  /** これ以上が3カラム。表示を保証する下限でもある */
  lg: 1200,
} as const;

/** セクション内のカード間隔（Figma 実測: セクション内の要素間は一律 16px）。 */
export const SECTION_GRID_GAP = 16;

/**
 * 固定横並びセクションの「1枚あたり最小幅」。wide / feature の段数は
 * `clamp(1, floor((センター内幅 + SECTION_GRID_GAP) / (最小幅 + SECTION_GRID_GAP)), 枚数)` になる。
 * compact は同じ式で4列になる帯だけ3列へ戻し、5枚が4+1にならないようにする。
 * 要件§3.3.1 が指定した両端（センター外 640〜720px と 1168px）も満たす。
 */
export const SECTION_CARD_MIN_WIDTH = {
  /** 4枚固定（対応が必要なやりとり）: センター外 640〜720px で 2×2 / 1168px で4列 */
  wide: 240,
  /** 5枚固定（分析KPI）: 5列を確保できるまでは3+2（4+1は禁止）/ 1168pxで5列 */
  compact: 176,
  /** 3枚固定（さらに成果を伸ばす）: センター外 640〜720px で1列 / 1168px で3列 */
  feature: 336,
} as const;

/** 2軸チャートの最小幅。下回る場合はチャート領域だけ横スクロールさせる（要件§3.3.1）。 */
export const CHART_MIN_WIDTH = 560;

export const LOCAL_STORAGE_ACCESS_TOKEN_KEY = "518bb79dc9bb888f72f686ce77f5feb8";
export const LOCAL_STORAGE_ACCESS_TOKEN_EXPIRES_AT_KEY = "381dd579d84447c7701272c76b109f40";

export const SNACK_BAR_AUTO_HIDE_DURATION_M_SEC = 5000;

export const STAFF_STORE_LIST_MONTHS_OFFSET = 1;
export const elevationApp = 3;
export const QUERY_MAX_LIMIT = 20000;
export const QUERY_INTERVAL_LIMIT = 2000;
export const INOPERABLE_INFLUENCER_STATUSES: APICompsSchema["InfluencerStatusEnum"][] = ["canceled"];

export const genderSelectModel: { type: string; value: string }[] = [
  {
    type: "male",
    value: "男性",
  },
  {
    type: "female",
    value: "女性",
  },
  {
    type: "other",
    value: "無回答",
  },
];

export const organizationTypeSelectModel: { type: APICompsSchema["OrganizationTypeEnum"]; value: string }[] = [
  {
    type: "company",
    value: "会社",
  },
  {
    type: "soleProprietor",
    value: "個人事業",
  },
];

export const StaffRoleEnumModel: { type: APICompsSchema["StaffRoleEnum"]; value: string }[] = [
  {
    type: "general",
    value: "一般スタッフ",
  },
  {
    type: "storeManager",
    value: "店長（ストアマネージャー）",
  },
  {
    type: "supervisor",
    value: "全体責任者",
  },
];
